import { render, staticRenderFns } from "./TemplateFileUpload.vue?vue&type=template&id=51705036&scoped=true"
import script from "./TemplateFileUpload.vue?vue&type=script&lang=js"
export * from "./TemplateFileUpload.vue?vue&type=script&lang=js"
import style0 from "./TemplateFileUpload.vue?vue&type=style&index=0&id=51705036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51705036",
  null
  
)

export default component.exports